import React, { useEffect, useState } from "react";
import { substackUrl } from "../data/content";

const links = [
  { label: "philosophy", href: "#philosophy" },
  { label: "building", href: "#building" },
  { label: "work", href: "#work" },
  { label: "writing", href: substackUrl, external: true },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#f6f5f2]/85 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="px-5 md:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          <a
            href="#top"
            className="font-display text-[15px] md:text-[17px] font-medium tracking-tight text-neutral-950 lowercase"
          >
            kamel jaber<sup className="text-[9px] align-super ml-0.5 text-neutral-400">™</sup>
          </a>

          <nav className="flex items-center gap-5 md:gap-9">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="underlink hidden sm:inline text-[12px] md:text-[13px] tracking-tight text-neutral-500 hover:text-neutral-950 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              className="underlink text-[12px] md:text-[13px] tracking-tight text-neutral-950"
            >
              contact
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
